import { yupResolver } from '@hookform/resolvers/yup';
import * as Yup from 'yup';

import { i18n } from '@/utils/i18n';

const verifyCodeSchema = Yup.object().shape({
  verificationCode: Yup.string().required(i18n.t('verifyCode.required'))
});

export type VerifyCodeData = Yup.InferType<typeof verifyCodeSchema>;

export const verifyCodeResolver = yupResolver(verifyCodeSchema);
